import List from '@mui/material/List'
import { Avatar } from '@mui/material'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import PersonIcon from '@mui/icons-material/PersonOutlined'
import { ReactNode } from 'react'
import { useTheme } from '@mui/material/styles'

const ProfileImageComponent = (props: {
  textColor?: string
  imageUrl?: string
  primaryText: string
  secondaryText: string
  subText: string
  customAvatarElement?: ReactNode
}) => {
  const theme = useTheme()

  return (
    <List>
      <Avatar
        src={props.imageUrl}
        style={{
          width: '100px',
          height: '100px',
          margin: 'auto',
          backgroundColor: theme.palette.primary.light,
          fontSize: '50px',
        }}
      >
        <PersonIcon fontSize="large" />
      </Avatar>
      {props.customAvatarElement && props.customAvatarElement}
      <ListItem style={{ textAlign: 'center' }}>
        <ListItemText>
          <Typography
            style={props.textColor ? { color: props.textColor } : {}}
            variant={'h6'}
          >
            <b> {props.primaryText && props.primaryText}</b>
          </Typography>
          <Typography
            style={props.textColor ? { color: props.textColor } : {}}
            variant={'body2'}
          >
            {props.secondaryText}
          </Typography>
          <Typography
            style={props.textColor ? { color: props.textColor } : {}}
            variant={'body2'}
            color={'textSecondary'}
          >
            {props.subText}
          </Typography>
        </ListItemText>
      </ListItem>
    </List>
  )
}

export default ProfileImageComponent
